module.exports = __webpack_public_path__ + "img/125.cd013b47.jpg";